import React, { useState } from "react";
import "./nav.css";
import { sendBookingEmail } from "../services/emailService";

function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Check if we're on the home page and get current path
  const currentPath = window.location.pathname;
  const isHomePage = currentPath === "/";

  const handleHamburger = () => setMenuOpen((open) => !open);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("");

  const handleBookClick = () => setDialogOpen(true);
  const handleDialogClose = () => {
    setDialogOpen(false);
    setSubmitStatus("");
    setName("");
    setEmail("");
    setMessage("");
  };

  const handleSend = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus("");

    try {
      const result = await sendBookingEmail(name, email, message);

      if (result.success) {
        setSubmitStatus("success");
        setTimeout(() => {
          setDialogOpen(false);
          setName("");
          setEmail("");
          setMessage("");
          setSubmitStatus("");
        }, 2000);
      } else {
        setSubmitStatus("error");
        console.error("Failed to send email:", result.error);
      }
    } catch (error) {
      setSubmitStatus("error");
      console.error("Error sending email:", error);
    }

    setIsSubmitting(false);
  };
  return (
    <nav className={`navbar ${!isHomePage ? "navbar-orange" : ""}`}>
      <div
        className={`navigation ${!isHomePage ? "navigation-orange" : ""}`}
        style={{ position: "relative" }}
      >
        <a
          href="/"
          className="logo"
          style={{ display: "flex", alignItems: "center" }}
        >
          <img
            src={require("./img/Steel Blade Photography Logo.png")}
            alt="Logo"
            style={{ height: "80px", marginLeft: "10px" }}
          />
          <p className="logo-text">SteelBlade Photography</p>
        </a>
        <button
          className="hamburger"
          style={{ display: "none" }}
          aria-label="Toggle navigation menu"
          onClick={handleHamburger}
        >
          &#9776;
        </button>
        <ul className={menuOpen ? "open" : ""}>
          <li>
            <a
              href="/"
              className={`nav-link ${currentPath === "/" ? "active" : ""}`}
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="/gallery"
              className={`nav-link ${currentPath === "/gallery" ? "active" : ""}`}
            >
              Gallery
            </a>
          </li>
          <li>
            <a
              href="/about"
              className={`nav-link ${currentPath === "/about" ? "active" : ""}`}
            >
              About
            </a>
          </li>
          <li>
            <a
              href="/pricing"
              className={`nav-link ${currentPath === "/pricing" ? "active" : ""}`}
            >
              Pricing
            </a>
          </li>
          <li>
            <button className="book-button" onClick={handleBookClick}>
              Book
            </button>
          </li>
        </ul>
        {dialogOpen && (
          <div className="dialog-overlay">
            <div className="dialog-box">
              <h2>Book a Session</h2>
              {submitStatus === "success" && (
                <div className="status-message success">
                  ✓ Email sent successfully! We'll get back to you soon.
                </div>
              )}
              {submitStatus === "error" && (
                <div className="status-message error">
                  ✗ Failed to send email. Please try again or contact us
                  directly.
                </div>
              )}
              <form onSubmit={handleSend}>
                <label>
                  Your Name:
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    disabled={isSubmitting}
                    placeholder="Enter your full name"
                  />
                </label>
                <label>
                  Your Email:
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={isSubmitting}
                    placeholder="your.email@example.com"
                  />
                </label>
                <label>
                  Message:
                  <textarea
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    disabled={isSubmitting}
                    placeholder="Tell us about your photography needs..."
                  />
                </label>
                <div style={{ marginTop: "10px" }}>
                  <button type="submit" disabled={isSubmitting}>
                    {isSubmitting ? "Sending..." : "Send"}
                  </button>
                  <button
                    type="button"
                    onClick={handleDialogClose}
                    style={{ marginLeft: "10px" }}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Nav;
